import { ButtonBladePlugin } from '../blade/button/plugin.js';
import { FolderBladePlugin } from '../blade/folder/plugin.js';
import { TabBladePlugin } from '../blade/tab/plugin.js';
import { BooleanInputPlugin } from '../input-binding/boolean/plugin.js';
import { NumberColorInputPlugin } from '../input-binding/color/plugin-number.js';
import { ObjectColorInputPlugin } from '../input-binding/color/plugin-object.js';
import { StringColorInputPlugin } from '../input-binding/color/plugin-string.js';
import { NumberInputPlugin } from '../input-binding/number/plugin.js';
import { Point2dInputPlugin } from '../input-binding/point-2d/plugin.js';
import { Point3dInputPlugin } from '../input-binding/point-3d/plugin.js';
import { Point4dInputPlugin } from '../input-binding/point-4d/plugin.js';
import { StringInputPlugin } from '../input-binding/string/plugin.js';
import { BooleanMonitorPlugin } from '../monitor-binding/boolean/plugin.js';
import { NumberMonitorPlugin } from '../monitor-binding/number/plugin.js';
import { StringMonitorPlugin } from '../monitor-binding/string/plugin.js';
import { BladeApiCache } from './blade-api-cache.js';
import { PluginPool } from './pool.js';
// Shared API cache for the default pool allows blade flexibility between different panes.
const sharedCache = new BladeApiCache();
export function createDefaultPluginPool() {
    const pool = new PluginPool(sharedCache);
    [
        // Input
        Point2dInputPlugin,
        Point3dInputPlugin,
        Point4dInputPlugin,
        StringInputPlugin,
        NumberInputPlugin,
        StringColorInputPlugin,
        ObjectColorInputPlugin,
        NumberColorInputPlugin,
        BooleanInputPlugin,
        // Monitor
        BooleanMonitorPlugin,
        StringMonitorPlugin,
        NumberMonitorPlugin,
        // Blade
        ButtonBladePlugin,
        FolderBladePlugin,
        TabBladePlugin,
    ].forEach((p) => {
        pool.register('core', p);
    });
    return pool;
}
